import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from 'src/app/config';
import { PdfZaUlazSirovinaService } from 'src/app/pdf-ovi/pdfZaUlazSirovina.service';
import { UlazSirovinaService } from './ulaz-sirovina.service';

@Component({
  selector: 'app-ulaz-sirovina',
  templateUrl: './ulaz-sirovina.component.html',
  styleUrls: ['./ulaz-sirovina.component.scss'],
})

export class UlazSirovinaComponent implements OnInit {
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');

  skladistaSirovina: any = [];
  stavkeUlazaSirovina: any = [];
  idOdabranogSkladistaSirovina: any;
  nazivOdabranogSkladistaSirovina: any;
  poruka: string;

  moguciOdabir: string[];
  grupBy: any = undefined;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: UlazSirovinaService, private pdfZaUlazSirovinaService: PdfZaUlazSirovinaService) {

    this.moguciOdabir = [
      'Po cijeni',
      'Sve',
    ];

    this.dohvatiSkladistaSirovina();
    this.dohvatiStavkeUlazaSirovina();

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().rekapitulacijaUlaza;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  dohvatiSkladistaSirovina() {
    this.skladistaSirovina = [];

    let podaciZaSlanje = {
      idfirma: localStorage.getItem('firma'),
      idkorisnik: localStorage.getItem('idsecuser')
    };
    //console.log(podaciZaSlanje);

    this.service.dohvatiSkladistaSirovina(podaciZaSlanje).subscribe((res) => {
      //console.log('SKLADISTA SIROVINA: ', res);
      if (res.success === true) {
        this.skladistaSirovina = res.data;
      }
    });
  }

  promjena(e){
    //console.log(e);
    if (e.value == "Sve") {
      this.grupBy = undefined;
      this.dohvatiStavkeUlazaSirovina();
    }else{
      this.grupBy =  'CIJENA',
      this.dohvatiStavkeUlazaSirovina();
    }
  }

  dohvatiStavkeUlazaSirovina() {
    this.poruka = 'Učitavanje...';
    this.stavkeUlazaSirovina = [];

    let podaciZaSlanje = {
      idkorisnik: localStorage.getItem('idsecuser'),
      idfirma: localStorage.getItem('firma'),
      idposlovnica: this.idOdabranogSkladistaSirovina,
      datumod: this.datumOdFormatiran,
      datumdo: this.datumDoFormatiran,
      dv_sifra: 'ULAZNIDOKUMENTI',
      grupirajpo: this.grupBy,
    };
    //console.log(podaciZaSlanje);

    this.service.dohvatiStavkeUlazaSirovina(podaciZaSlanje).subscribe((res) => {
      //console.log('SKLADISTA SIROVINA: ', res);
      if (res.success === true) {
        this.stavkeUlazaSirovina = res.data;
      }

      if (this.stavkeUlazaSirovina.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    
    this.dohvatiStavkeUlazaSirovina();
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
    
    this.dohvatiStavkeUlazaSirovina();
  }

  onChangeSkladisteSirovina(e) {
    //console.log(e);
    if(e.value == null){
      this.idOdabranogSkladistaSirovina = null;
      //this.nazivOdabranogSkladistaSirovina = "SVE POSLOVNICE";
    }else{
      this.idOdabranogSkladistaSirovina = e.value.idposlovnica;
      this.nazivOdabranogSkladistaSirovina = e.value.po_naziv;
    }
    
    this.dohvatiStavkeUlazaSirovina();
  }

  pdfIzdatnicaUlazaSirovina() {
    this.pdfZaUlazSirovinaService.pdfIzdatnicaUlazaSirovina(
      this.stavkeUlazaSirovina,
      this.nazivOdabranogSkladistaSirovina,
      this.datumDo,
      this.datumOd
    );
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  ngOnInit() {
  }
}
